import type { OperatorDeviceContext } from "@shared/identity";
import { readLocalStorage, writeLocalStorage } from "./storage";

const DEVICE_CONTEXT_STORAGE_KEY = "posnext.operator-device-context";
const CLIENT_ID_STORAGE_KEY = "posnext.operator-client-id";

export function storeOperatorDeviceContext(context: OperatorDeviceContext): void {
  writeLocalStorage(DEVICE_CONTEXT_STORAGE_KEY, JSON.stringify(context));
}

export function readOperatorDeviceContext(): OperatorDeviceContext | null {
  const local = readLocalStorage(DEVICE_CONTEXT_STORAGE_KEY);
  if (local) {
    try {
      const parsed = JSON.parse(local) as Partial<OperatorDeviceContext>;
      if (parsed.storeId && parsed.deviceId && parsed.clientId && parsed.label) {
        return { storeId: parsed.storeId, deviceId: parsed.deviceId, clientId: parsed.clientId, label: parsed.label };
      }
    } catch {
      // Ignore malformed local device state and require a fresh bootstrap.
    }
  }
  return null;
}

export function readSharedOperatorClientId(): string | null {
  return readLocalStorage(CLIENT_ID_STORAGE_KEY);
}

export function ensureSharedOperatorClientId(createId: () => string): string {
  const existing = readSharedOperatorClientId();
  if (existing) return existing;
  const clientId = createId();
  writeLocalStorage(CLIENT_ID_STORAGE_KEY, clientId);
  return clientId;
}
